<template>
  <div v-if="isAbout === 2">
    <div v-if="reportsLoading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>
    <div
      v-if="report_list.length === 0 && !reportsLoading"
      style="text-align: center; padding: 30px;"
    >
      No reported posts or comments
    </div>
    <div v-if="report_list.length !== 0">
      <div class="heading_container sort-dropdown">
        <p class="report_heading">Reports</p>
        <a-dropdown
          style="margin-top:7px"
          :trigger="['click']"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <p class="sort-text">
            Show
            <span style="font-weight: 700;">{{ sortList[sortKey] }}</span>
            <font-awesome-icon
              size="lg"
              style="margin-left: 8px;"
              :icon="['fas', 'angle-down']"
            />
          </p>
          <template #overlay>
            <a-menu @click="e => sortReports(e.key)">
              <a-menu-item key="">All</a-menu-item>
              <a-menu-item key="post">Posts</a-menu-item>
              <a-menu-item key="comment">Comments</a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <ReportCard
        v-for="post in report_list"
        :key="post.id"
        :post="post.reported_post"
        :refresh="() => fetchReports(false)"
      />
      <div
        v-if="total_count > items"
        :style="{
          padding: '30px',
          display: 'flex',
          justifyContent: 'center'
        }"
      >
        <a-pagination
          v-model="page"
          class="dovemed-custom-pagination"
          :total="total_count"
          show-less-items
          :pageSize="items"
          @change="fetchReports"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import ReportCard from "./ReportCard.vue";

const AboutCircleRepository = RepositoryFactory.get("aboutCircle");

export default {
  name: "Reports",
  components: {
    ReportCard
  },
  props: {
    scroll: HTMLDivElement
  },
  data() {
    return {
      reportsLoading: false,
      page: 1,
      items: 10,
      total_count: 0,
      sortKey: "",
      sortList: {
        "": "All",
        post: "Posts",
        comment: "Comments"
      },
      report_list: []
    };
  },
  created() {
    this.fetchReports();
  },
  methods: {
    sortReports(sort) {
      this.sortKey = sort;
      this.fetchReports();
    },
    fetchReports(isLoading = true) {
      if (isLoading) {
        this.reportsLoading = true;
      }
      if (isLoading) {
        this.scroll.scrollIntoView();
      }
      this.isAbout = 2;
      AboutCircleRepository.getReports(
        this.currentCircle.id,
        this.page,
        this.items,
        this.sortKey
      )
        .then(res => {
          this.reportsLoading = false;
          if (res.data.data.hasOwnProperty("data")) {
            this.report_list = res.data.data.data.map((post, index) => {
              console.log("index", index);
              if (post.post) {
                post.reported_post = post.post.post[0];
                post.reported_post.content_type = "post";
                post.reported_post.reaction.flag = post.post.reaction.flag;
              } else if (post.event) {
                post.reported_post = post.event;
                post.reported_post.content_type = "event";
                post.reported_post.post_time = post.event.created_at;
                post.reported_post.user = [post.event.user_details];
              } else if (post.job) {
                post.reported_post = post.job;
                post.reported_post.content_type = "job";
                post.reported_post.post_time = post.job.created_at;
                post.reported_post.user = [post.job.user_details];
              } else if (post.press) {
                post.reported_post = post.press;
                post.reported_post.content_type = "press";
                post.reported_post.post_time = post.press.created_at;
                post.reported_post.user = [post.press.user_details];
              } else if (post.poll) {
                post.reported_post = post.poll;
                post.reported_post.content_type = "poll";
                post.reported_post.post_time = post.poll.created_at;
                post.reported_post.reaction.flag = post.poll.reaction.flag;
                post.reported_post.user = [post.poll.user];
              } else if (post.question) {
                post.reported_post = post.question.question[0];
                post.reported_post.content_type = "question";
                post.reported_post.post_time =
                  post.question.question[0].asked_time;
                post.reported_post.reaction.flag = post.question.reaction.flag;
              } else if (post.comment) {
                const comment = post;
                post = post.comment;
                if (post.post) {
                  post.reported_post = post.post.post[0];
                  post.reported_post.content_type = "post";
                } else if (post.event) {
                  post.reported_post = post.event;
                  post.reported_post.content_type = "event";
                  post.reported_post.post_time = post.event.created_at;
                  post.reported_post.user = [post.event.user_details];
                } else if (post.job) {
                  post.reported_post = post.job;
                  post.reported_post.content_type = "job";
                  post.reported_post.post_time = post.job.created_at;
                  post.reported_post.user = [post.job.user_details];
                } else if (post.press) {
                  post.reported_post = post.press;
                  post.reported_post.content_type = "press";
                  post.reported_post.post_time = post.press.created_at;
                  post.reported_post.user = [post.press.user_details];
                } else if (post.poll) {
                  post.reported_post = post.poll;
                  post.reported_post.content_type = "poll";
                  post.reported_post.post_time = post.poll.created_at;
                  post.reported_post.user = [post.poll.user];
                } else if (post.question) {
                  post.reported_post = post.question.question[0];
                  post.reported_post.content_type = "question";
                  post.reported_post.post_time =
                    post.question.question[0].asked_time;
                }
                post.reported_post.reaction = { flag: post.reaction.flag };
                post.reported_post.is_comment = true;
                post.reported_post.comment_text = post.comment_text;
                post.reported_post.comment_attach_url = post.comment_attach_url;
                post.reported_post.comment_name =
                  post.user_circle[0].role === "doctor" ||
                  post.user_circle[0].role === "physician"
                    ? post.user_circle[0].first_name +
                      " " +
                      post.user_circle[0].last_name
                    : post.user_circle[0].display_name;
                post.reported_post.comment_role = post.user_circle[0].role;
                post.reported_post.comment_image = post.user_circle[0].url;
                post.reported_post.comment_user = post.user_circle[0];
                post.reported_post.comment_time = post.created_at;
                post.reported_post.commented_on_id = post.commented_on_id;
                post.reported_post.commented_on_type = post.commented_on_type;
                post.reported_post.comment_count = post.comment_count;
                post.reported_post.comment_id = post.id;
                post.reported_post.reply_to_reply = post.reply_to_reply;
                post.reacted_on_id = comment.reacted_on_id;
                post.reacted_on_type = comment.reacted_on_type;
              } else {
                post.reported_post = null;
              }
              if (post.reported_post) {
                post.reported_post.reacted_on_id = post.reacted_on_id;
                post.reported_post.reacted_on_type = post.reacted_on_type;
              }
              return post;
            });
            this.total_count = parseInt(res.data.data.paginator.total_count);
          } else {
            this.report_list = [];
            this.total_count = 0;
          }
        })
        .catch(err => {
          this.reportsLoading = false;
          this.report_list = [];
          this.total_count = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.heading_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0px 16px 0px;
  .sort-text {
    font-weight: 400;
    font-size: 14px;
    color: #0f1734;
    margin-bottom: 0px;
    cursor: pointer;
    white-space: nowrap;
    margin-left: 20px;
  }
  .report_heading {
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    color: #0f1734;
    margin: 0px;
  }
}
.card_info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  margin: 0px;
  padding: 16px;
  .bold {
    font-weight: 700;
  }
}
.card_avatar_container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  gap: 16px;
  .name {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #0f1734;
    margin-bottom: 4px;
  }
  .time {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #94a3b8;
    margin: 0px;
  }
}
.card_title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  padding: 0px 16px 16px 16px;
  margin: 0px;
}
.card_description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #47556e;
  padding: 0px 16px 16px 16px;
  margin: 0px;
}
.seeMore {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #94a3b8;
  cursor: pointer;
  margin: 0px 16px 16px 16px;
}
.tag_container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0px 16px 16px 16px;
  .tag {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    color: #2a71d4;
    background: #e1eaf7;
    border-radius: 4px;
    padding: 4px 8px;
    margin: 0px;
  }
}
.comment_count {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #0f1734;
  padding: 0px 16px 16px 16px;
  margin: 0px;
}
.card_footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  .card_button {
    padding: 12px 24px;
    border-radius: 6px;
    width: fit-content;
    border: none;
    font-weight: 700;
    font-size: 14px;
  }
  .card_button2 {
    padding: 12px 24px;
    border-radius: 6px;
    width: fit-content;
    border: none;
    font-weight: 700;
    font-size: 14px;
    background: #e2e8f0;
    color: #47556e;
  }
}
.comment_container {
  padding: 16px;
  margin: 16px;
  background: rgba(255, 215, 204, 0.3);
  border-radius: 4px;
  .header {
    display: flex;
    align-items: center;
    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #0f1734;
      margin-bottom: 4px;
      padding-left: 16px;
    }
  }
}
.full_thread_container {
  display: flex;
  justify-content: flex-end;
  padding: 0px 16px 16px 16px;
  .full_thread {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin: 0px;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/aboutCircle/Reports.vue